const useOnBlur = ({ setNeedSaveRef }: { setNeedSaveRef: { current: boolean } }) => {
  return ({ currentState, updateState, overrideState, needToOverrideState, workingStateRef }) => {
    if (!currentState) {
      setNeedSaveRef.current = true;
      updateState(workingStateRef.current);
      return;
    }

    setNeedSaveRef.current = true;

    if (needToOverrideState) {
      overrideState(currentState);
      return;
    }

    updateState(currentState);
  };
};

export default useOnBlur;
